/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  meta.ts
 */

import { priceChartMetaSelectorsCreator, selectLocalePriceChart } from '../priceChart'

const localePriceChartMetaSelectors = priceChartMetaSelectorsCreator(selectLocalePriceChart)

export const {
  selectCityPriceChartMeta,
  selectHoodPriceChartMeta,
  selectCityPriceChartCurrentKey,
  selectCityPriceChartFetchingError,
  selectCityPriceChartFetching,
  selectCityPriceChartFetchingKey,
  selectHoodPriceChartCurrentKey,
  selectHoodPriceChartFetchingError,
  selectHoodPriceChartFetching,
  selectHoodPriceChartFetchingKey,
} = localePriceChartMetaSelectors
